module.exports = __webpack_public_path__ + "static/medicare-champions-ca8ea12f7dcc5558669f254c12c92a69.png";